import React, { useState } from "react";
import styles from "./UpdatePhone.module.css";
import { useForm, Controller } from "react-hook-form";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import validator from "validator";
import useGeoLocation from "@/services/useGeoLocation";
import Link from "next/link";

interface UpdatePhoneProps {
  setStep: (step: number) => void;
  setMobileNumber: (number: string) => void;
  mobileNumber: string;
  handleCountryCodeChange: (country: any) => void;
  handlesendOTP: () => void;
}

interface FormData {
  phone: string;
}
const UpdatePhone = ({
  setMobileNumber,
  mobileNumber,
  handleCountryCodeChange,
  handlesendOTP,
}: UpdatePhoneProps) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormData>({
    defaultValues: {
      phone: mobileNumber || "",
    },
  });

  const [phoneNumberError, setPhoneNumberError] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const geoLocationData: any = useGeoLocation();

  const onSubmit = async (data: FormData) => {
    if (!isValidPhoneNumber(data?.phone)) {
      setPhoneNumberError("Valid phone number is required");

      return;
    }
    setPhoneNumberError("");

    try {
      setIsLoading(true);
      await handlesendOTP();
      setMobileNumber(data?.phone);
    } catch (error) {
      console.error("Error sending OTP:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.otpCompoContainer}>
      <div className={styles.toptextContainer}>
        <h1 className={styles.otpHeader}>Update Phone Number</h1>
        <p className={styles.otpSubText}>
          Please enter your new mobile number below to update.
        </p>
      </div>
      <form
        action=""
        onSubmit={handleSubmit(onSubmit)}
        className={styles.formWidth}
      >
        <div
          className={`${styles.fieldInPut} ${styles.formContainer} ${
            isFocused ? styles.inputFocused : ""
          }`}
        >
          <Controller
            name="phone"
            control={control}
            rules={{
              required: "Phone number is required",
              validate: (value) => (value ? true : "Phone number is required"),
            }}
            render={({ field }) => (
              <PhoneInput
                {...field}
                className={styles.PhoneInput}
                autoComplete="off"
                value={field.value}
                defaultCountry={geoLocationData?.countryCode}
                international
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                countryCallingCodeEditable={false}
                onChange={(value) => {
                  const phoneNumber = value ? value.toString() : "";
                  field.onChange(phoneNumber);
                  setMobileNumber(phoneNumber);

                  if (!phoneNumber) {
                    setPhoneNumberError("Phone number is required");
                  } else if (!validator.isMobilePhone(phoneNumber)) {
                    setPhoneNumberError("Valid phone number required");
                  } else {
                    setPhoneNumberError("");
                  }
                }}
                onCountryChange={handleCountryCodeChange}
              />
            )}
          />
        </div>

        <div className="mt-3">
          {phoneNumberError ? (
            <small className={styles.error}>{phoneNumberError}</small>
          ) : (
            errors?.phone && (
              <small className={styles.error}>{errors?.phone?.message}</small>
            )
          )}
        </div>
        <button
          className={`${styles.verifyBtn} ${isLoading ? styles.disabled : ""}`}
          disabled={isLoading}
          type="submit"
        >
          {isLoading ? "Sending..." : "Send OTP"}
        </button>
        <div>
          <p className={styles.smallText}>
            For assistance, please
            <Link
              title="Contact Us"
              href={"/contact-us-for-admissions-and-other-queries-regenesys"}
            >
              <span>reach out to us</span>
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
};

export default UpdatePhone;
